export default class User {
  email: string | null = null;
  userName: string | null = null;
  gdprConsentDate: string | null = null;
  statusId: number | null = null;
  creatorId: number | null = null;
  creatorName: string | null = null;
  created: string | null = null;
  id: number | null = null;
}
